import { FormValues } from "@/types/loan";
import { 
  validateEmail, 
  validatePhoneNumber, 
  validateName, 
  validateLoanAmount, 
  validateLoanTerm
} from "@/utils/security";

export interface ValidationResult {
  valid: boolean;
  message?: string;
}

export const validateFormData = (data: FormValues): ValidationResult => {
  // Validate required fields
  if (!data.firstName || !data.lastName || !data.email || !data.phoneNumber) {
    return { valid: false, message: "Täytä kaikki pakolliset kentät" };
  }
  
  // Validate name fields
  if (!validateName(data.firstName)) {
    return { valid: false, message: "Etunimi sisältää virheellisiä merkkejä" };
  }
  
  if (!validateName(data.lastName)) {
    return { valid: false, message: "Sukunimi sisältää virheellisiä merkkejä" };
  }
  
  // Validate email
  if (!validateEmail(data.email)) {
    return { valid: false, message: "Tarkista sähköpostiosoitteen muoto" };
  }
  
  // Validate phone number
  if (!validatePhoneNumber(data.phoneNumber)) {
    return { valid: false, message: "Tarkista puhelinnumeron muoto" };
  }
  
  // Validate loan amount
  if (!validateLoanAmount(data.loanAmount)) {
    return { valid: false, message: "Lainasumman tulee olla 1000-100000 euroa" };
  }
  
  // Validate loan term
  if (!validateLoanTerm(data.loanTerm)) {
    return { valid: false, message: "Laina-ajan tulee olla 1-120 kuukautta" };
  }
  
  // Validate terms acceptance
  if (!data.termsAccepted) {
    return { valid: false, message: "Sinun täytyy hyväksyä käyttöehdot jatkaaksesi" };
  }
  
  return { valid: true };
};